module.exports = __webpack_public_path__ + "static/media/lithuania.65f9d2fd.png";